"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _Sidebar = _interopRequireDefault(require("./Sidebar"));

exports["default"] = _Sidebar["default"];